module.exports = __webpack_public_path__ + "static/media/pdf.e274ed9a.png";